import {
  HomeIcon,
  ClipboardListIcon,
  PresentationChartLineIcon,
  OfficeBuildingIcon,
  SearchCircleIcon,
  AdjustmentsIcon,
  LibraryIcon,
} from "@heroicons/react/outline";
import { NavItemInterface } from "../SidebarNav";

export const navItemObjects: NavItemInterface[] = [
  {
    name: "My Company",
    path: "company",
    icon: LibraryIcon,
    permissions: ["VIEW_COMPANY_DASHBOARD"],
  },
  {
    name: "My Dashboard",
    path: "dashboard",
    icon: HomeIcon,
    subMenu: [
      { name: "My Tasks", path: "/tasks" },
      {
        name: "My Deliverables",
        path: "/deliverables",
      },
      {
        name: "My Milestones",
        path: "/milestones",
      },
      {
        name: "My Approvals",
        permissions: ["LIST_APPROVALS"],
        path: "/approvals",
      },
    ],
  },
  {
    name: "Rover",
    path: "rover",
    icon: PresentationChartLineIcon,
    subscription: "ROVER",
    permissions: [
      "LIST_PARTNER_PROPOSALS",
      "LIST_CLIENT_APPLICATIONS",
      "LIST_APPLICATION_FORMS",
    ],
    // subMenu: [
    //   {
    //     name: "Client Applications",
    //     path: "/client-applications",
    //     permissions: ["LIST_CLIENT_APPLICATIONS"],
    //   },
    //   {
    //     name: "Partner Proposals",
    //     path: "/partner-proposals",
    //     permissions: ["LIST_PARTNER_PROPOSALS"],
    //   },
    //   {
    //     name: "Application Forms",
    //     path: "/application_forms",
    //     permissions: ["LIST_APPLICATION_FORMS"],
    //   },
    //   {
    //     name: 'FBDI',
    //     path: '/fbdi',
    //     permissions: ['LIST_PARTNER_PROPOSALS'],
    //   },
    // ],
  },
  {
    name: "Sherpa",
    path: "sherpa",
    subscription: "SHERPA",
    icon: OfficeBuildingIcon,
    permissions: [
      "LIST_PROJECTS",
      "LIST_ALL_PROJECTS",
      "VIEW_SHERPA_DASHBOARD",
    ],
    subMenu: [
      {
        name: "Dashboard",
        path: "/dashboard",
        permissions: ["VIEW_SHERPA_DASHBOARD"],
      },
      {
        name: "Projects",
        path: "/projects",
        permissions: ["LIST_PROJECTS", "LIST_ALL_PROJECTS"],
      },
      {
        name: "Project Templates",
        path: "/project-templates",
        permissions: ["LIST_PROJECT_TEMPLATES"],
      },
    ],
  },
  {
    name: "Vendor Management",
    path: "vendor",
    icon: SearchCircleIcon,
    permissions: ["LIST_VENDORS"],
  },
  {
    name: "Administration",
    path: "administration",
    icon: AdjustmentsIcon,
    permissions: ["LIST_USERS", "LIST_TITLES", "LIST_CATEGORIES", "LIST_ROLES"],
    subMenu: [
      { name: "Users", path: "/users", permissions: ["LIST_USERS"] },
      {
        name: "Organizational Titles",
        path: "/organizational-titles",
        permissions: ["LIST_TITLES"],
      },
      {
        name: "Roles and Permission",
        path: "/roles-and-permissions",
        permissions: ["LIST_ROLES"],
      },
      {
        name: "Category Management",
        path: "/category-management",
        permissions: ["LIST_CATEGORIES"],
      },
    ],
  },
];

export const sageAdminNavItemObjects: NavItemInterface[] = [
  {
    name: "Clients",
    path: "clients",
    icon: ClipboardListIcon,
    permissions: ["LIST_CLIENTS"],
  },
  {
    name: "Administration",
    path: "administration",
    icon: AdjustmentsIcon,
    permissions: ["LIST_USERS", "LIST_TITLES", "LIST_ROLES"],
    subMenu: [
      { name: "Users", path: "/users", permissions: ["LIST_USERS"] },
      {
        name: "Organizational Titles",
        path: "/organizational-titles",
        permissions: ["LIST_TITLES"],
      },
      {
        name: "Roles and Permission",
        path: "/roles-and-permissions",
        permissions: ["LIST_ROLES"],
      },
      {
        name: "Widgets Management",
        path: "/widgets-management",
        permissions: ["MANAGE_COMPANY_WIDGETS"],
      },
    ],
  },
];
